export const MIN_SEARCH_DRIVER_AGE = 18;
export const MAX_SEARCH_DRIVER_AGE = 99;
export const YOUNG_DRIVER_AGE = 25;
